import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import { SHOP_ROUTE } from '../routes';

// Компонент для защиты админских маршрутов
const AdminRoute = ({ children }) => {
    const { user } = useContext(Context);
    const location = useLocation();

    if (!user.isAuth) {
        // Если не авторизован - отправляем на главную
        return <Navigate to={SHOP_ROUTE} state={{ from: location }} replace />;
    }

    if (!user.isAdmin) {
        // Если авторизован, но не админ - тоже на главную
        return <Navigate to={SHOP_ROUTE} state={{ from: location }} replace />;
    }

    return children;
};

export default observer(AdminRoute);